import { ArrowRight, CalendarDays } from 'lucide-react';
import { EventCard } from '../components/EventCard';
import { Layout } from '../components/Layout';
import { PageHero } from '../components/PageHero';
import { imgCongregacionWide } from '../assets';
import { useEvents, useReveal } from '../hooks';

export function EventosPage() {
  const { events, status } = useEvents();
  useReveal(status);

  return (
    <Layout>
      <PageHero
        kicker="Eventos"
        title={
          <>
            Lo que Dios está <em>haciendo</em> en la casa.
          </>
        }
        lead="Retiros, noches especiales, alcance y celebraciones. Revisa fechas y detalles — todo en horario de Ciudad Juárez."
        image={imgCongregacionWide}
        imageAlt="Congregación de Tercer Cielo reunida en un encuentro"
      >
        <a className="button button-gold" href="#eventos-lista">
          Ver próximos eventos <ArrowRight size={18} aria-hidden="true" />
        </a>
      </PageHero>

      <section className="section-space events-list-section" id="eventos-lista" aria-labelledby="eventos-lista-title">
        <div className="page-shell">
          <div className="section-heading reveal">
            <div>
              <p className="section-kicker">
                <span /> Agenda
              </p>
              <h2 id="eventos-lista-title">Próximos encuentros.</h2>
            </div>
            <p>Horarios en Ciudad Juárez, Chihuahua. Elige un evento para ver todos los detalles.</p>
          </div>

          {status === 'loading' && <EventsStatusBox>Cargando la agenda…</EventsStatusBox>}
          {status === 'error' && (
            <EventsStatusBox>
              No pudimos cargar los eventos en este momento. Intenta de nuevo en unos minutos.
            </EventsStatusBox>
          )}
          {status === 'ready' && events.length === 0 && (
            <EventsStatusBox>
              Pronto anunciaremos nuevos eventos. Mientras tanto, te esperamos en nuestros servicios semanales.
            </EventsStatusBox>
          )}
          {status === 'ready' && events.length > 0 && (
            <div className="events-grid">
              {events.map((event) => (
                <EventCard key={`${event.uid}-${event.start.toISOString()}`} event={event} />
              ))}
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}

function EventsStatusBox({ children }: { children: string }) {
  return (
    <div className="events-empty reveal">
      <CalendarDays size={28} aria-hidden="true" />
      <p>{children}</p>
    </div>
  );
}
